import { render, staticRenderFns } from "./makeup.vue?vue&type=template&id=67891019&scoped=true&"
import script from "./makeup.vue?vue&type=script&lang=js&"
export * from "./makeup.vue?vue&type=script&lang=js&"
import style0 from "./makeup.vue?vue&type=style&index=0&id=67891019&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67891019",
  null
  
)

export default component.exports